import { Gauge, Boxes, ShoppingCart, Users, MessageCircleQuestion, Globe, Plus, Newspaper, Package, Star, Percent, Truck, Handshake, Home, Layers, PanelTop, Settings, PhoneCall, ShieldCheck, ShieldAlert, TrendingUp, Store, History, MessagesSquare, Rocket, Activity } from 'lucide-react';
import type { NavGroup } from '@/components/layout/AppShell';

export const rxkModuleIcon = <Gauge className="w-4 h-4" />;
export const rxkModuleTitle = 'RxK Admin (RxK 관리)';

export const rxkNavGroups: NavGroup[] = [
  {
    items: [
      { label: 'Dashboard (대시보드)', href: '/admin', icon: <Gauge className="w-4 h-4" />, end: true },
      { label: 'Orders (주문)', href: '/admin/orders', icon: <ShoppingCart className="w-4 h-4" /> },
      { label: 'Daily Summary', href: '/admin/daily-summary', icon: <TrendingUp className="w-4 h-4" /> },
      { label: 'Analytics', href: '/admin/analytics', icon: <Activity className="w-4 h-4" /> },
      { label: 'Inventory (재고)', href: '/admin/inventory', icon: <Boxes className="w-4 h-4" /> },
      { label: 'Check a Code', href: '/admin/verify-code', icon: <ShieldCheck className="w-4 h-4" /> },
      { label: 'Couriers', href: '/admin/couriers', icon: <Truck className="w-4 h-4" /> },
      { label: 'Discounts', href: '/admin/discounts', icon: <Percent className="w-4 h-4" /> },
      { label: 'Customers (고객)', href: '/admin/customers', icon: <Users className="w-4 h-4" /> },
      { label: 'Fraud Check', href: '/admin/fraud-check', icon: <ShieldAlert className="w-4 h-4" /> },
      { label: 'Customer Followup', href: '/admin/followup', icon: <PhoneCall className="w-4 h-4" /> },
      { label: 'Communications', href: '/admin/communications', icon: <MessagesSquare className="w-4 h-4" /> },
      { label: 'Reseller', href: '/admin/resellers', icon: <Handshake className="w-4 h-4" /> },
      { label: 'Stock Overview', href: '/admin/resellers/stock', icon: <Boxes className="w-4 h-4" /> },
      { label: 'Retailers', href: '/admin/retailers', icon: <Store className="w-4 h-4" /> },
      { label: 'Q&A (고객 문의)', href: '/admin/qna', icon: <MessageCircleQuestion className="w-4 h-4" /> },
      { label: 'Product Reviews', href: '/admin/reviews', icon: <Star className="w-4 h-4" /> },
    ],
  },
  {
    title: 'Website',
    items: [
      { label: 'Pages', href: '/admin/website', icon: <Globe className="w-4 h-4" /> },
      { label: 'Home Page', href: '/admin/website/home-page', icon: <Home className="w-4 h-4" /> },
      { label: 'Products Page', href: '/admin/website/products-page', icon: <Layers className="w-4 h-4" /> },
      { label: 'Header & Footer', href: '/admin/website/header-footer', icon: <PanelTop className="w-4 h-4" /> },
      { label: 'Shipping & Returns', href: '/admin/website/shipping-page', icon: <Truck className="w-4 h-4" /> },
      { label: 'Articles', href: '/admin/articles', icon: <Newspaper className="w-4 h-4" /> },
      { label: 'Products Content', href: '/admin/products', icon: <Package className="w-4 h-4" /> },
      { label: 'Custom Pages', href: '/admin/pages', icon: <Plus className="w-4 h-4" /> },
      { label: 'Landing Pages', href: '/admin/landing-pages', icon: <Rocket className="w-4 h-4" /> },
      { label: 'Settings', href: '/admin/website/settings-page', icon: <Settings className="w-4 h-4" /> },
      { label: 'Activity Log', href: '/admin/activity-log', icon: <History className="w-4 h-4" /> },
    ],
  },
];

// Single source of truth for role-based page permissions: every href in
// rxkNavGroups is a "page" a role can be granted/denied in rxk_role_permissions
// — derived here instead of duplicated in a separate list so adding/removing
// a sidebar item automatically keeps the permissions matrix in sync.
export const rxkPageKeys: string[] = rxkNavGroups.flatMap((g) => g.items.map((i) => i.href));
export const rxkPageLabels: Record<string, string> = Object.fromEntries(
  rxkNavGroups.flatMap((g) => g.items.map((i) => [i.href, i.label] as const)),
);

// Longest-matching-prefix lookup — a sub-route like /admin/orders/:id/invoice
// inherits its parent sidebar page's permission (/admin/orders) rather than
// needing its own separate permission row. Routes with no sidebar entry at
// all (e.g. /admin/profile) resolve to /admin (Dashboard) since every other
// admin href is itself a segment under /admin.
export function matchPageKey(pathname: string): string | null {
  let best: string | null = null;
  for (const key of rxkPageKeys) {
    if (pathname === key || pathname.startsWith(`${key}/`)) {
      if (!best || key.length > best.length) best = key;
    }
  }
  return best;
}
